export const targetTemplateTokensVistaprint = [
  'sb9c819bb-7970-4cd4-9d40-17f23a8513f2:v1..9a70c5d6-f2d5-410c-9adf-4a719eb0e9fc',
  's251d5a2d-b714-4c3d-b7e1-0c8dda5e1720:v1..a1e07cbc-043c-4868-a7d5-c7cbacbe8961',
];

export const targetTemplateTokensContentSolutionTestTenant = [
  'scbf20dd3-87d7-4edb-85f8-47dbcd04e283:v1..9a70c5d6-f2d5-410c-9adf-4a719eb0e9fc',
  'sd4b834e7-8485-4ec7-a9ac-42f3de9b09a7:v1..a1e07cbc-043c-4868-a7d5-c7cbacbe8961',
];
